import { ContactMailSharp } from '@material-ui/icons';
import React, { memo } from 'react';
import {useState} from 'react';
import { Handle } from 'react-flow-renderer';
import DesignCard from './DesignCard';

import email from '../img/email.png';
import './dnd.css';
import EmailIcon from '@material-ui/icons/Email';

export default memo(({ data }) => {

  const designerIconStyle = {
    // backgroundImage:'linear-gradient(to bottom, grey, royalblue)', color:'white', padding:'5px', borderRadius:'20px', marginLeft:'10px'
    padding:'0px', color:'royalblue', borderRadius:'20px', marginTop:'10px', marginLeft:'10px', marginRight:'10px'
}


    const [img, setImg] = useState(null);


    
    return (
    <div className="designnode">
      <Handle
        type="target"
        position="top"
        style={{ background: '#555' }}
        onConnect={(params) => console.log('handle onConnect', params)}
      />
      <div className="row">
      <EmailIcon fontSize='medium' style={designerIconStyle} draggable={false}/>

      {/* <img draggable={false} src={email} width='50' height='50'></img> */}
      </div>
      <DesignCard attributes={data.attributes} name={data.label}/>

      <Handle
        type="source"
        position="bottom"
        id="b2"
        style={{ bottom: -5, top: 'auto', background: '#555' }}
      />
    </div>
  );

});